<template>
    <div>
        <div class="row data-form">
            <div class="col-12 col-md-12">
                <ValidationObserver ref="importForm">
                    <b-row>
                        <b-col cols="12">
                            <ValidationProvider name="file" rules="required" v-slot="{valid, errors}">
                                <b-form-group :label="$t('excel_file')">
                                    <div class="d-flex custom-file-upload">
                                        <b-form-file
                                            v-model="form.file"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            :placeholder="$t('select_file')"
                                            :drop-placeholder="$t('drop_file')"
                                            ref="fileInput"
                                            multiple></b-form-file>
                                        <b-button variant="outline-secondary" @click="$refs.fileInput.$el.childNodes[0].click();">{{$t('browse')}}</b-button>
                                    </div>
                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" class="d-flex">
                            <DownloadExcelTemplate :code="'prep_students_bulk_attendance_hour_set'"/>
                            <b-button variant="primary" @click="sendForm">{{$t('import') || toUpperCase}}</b-button>
                        </b-col>
                    </b-row>
                </ValidationObserver>
            </div>
        </div>
        <CommonModal :size="'lg'" ref="informModal" @bHideModalHeaderClose="closeModal">
            <template v-slot:CommonModalTitle>
                <div>{{ $t('information') }}</div>
            </template>
            <template v-slot:CommonModalContent>
                <div v-for="item in informData" :key="item.student_course_id">
                    <b-alert v-if="item.status == 'FAIL'" show variant="danger">
                        <div v-html="$t('bulk_attendance_hour_unsuccess',{
                                    class: item.class,
                                    student_program_id: item.student_program_id,
                                    module: item.module,
                                    level: item.level,
                            })">

                        </div>
                    </b-alert>
                </div>
            </template>
        </CommonModal>
    </div>
</template>
<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import excelImportTemplate from "@/services/ExcelImportTemplate";
import PrepStudentService from "@/services/PrepStudentService";
import DownloadExcelTemplate from "@/components/interactive-fields/DownloadExcelTemplate.vue";

export default {
    components: {
        DownloadExcelTemplate,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            form: {
                file: null,
            },
            informData: []
        }
    },
    metaInfo() {
        return {
            title: this.$t("import")
        }
    },
    methods: {
        async sendForm() {
            let isValid = await this.$refs.importForm.validate()
            if (isValid) {
                let formData = new FormData();
                formData.append('file', this.form.file[0])

                PrepStudentService.bulkHourSet(formData)
                    .then((response) => {
                        this.informData = response.data.data

                        this.$refs.informModal.$refs.commonModal.show()
                    })
                    .catch(error => {
                        this.showErrors(error)
                    })
            }

        },
        closeModal() {
            this.$refs.informModal.$refs.commonModal.hide()
            this.$emit('bulkAttendanceHourSuccess', true)
        },

    },

};
</script>
